import { JSX } from 'react'

import { IconProps } from '../../icon'

const Payment: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M34.8462 12H15.1538C11.7569 12 9 14.7569 9 18.1538V29.641C9 33.0379 11.7569 35.7949 15.1538 35.7949H34.8462C38.2431 35.7949 41 33.0379 41 29.641V18.1538C41 14.7569 38.2431 12 34.8462 12ZM15.1538 14.4615H34.8462C36.881 14.4615 38.5385 16.119 38.5385 18.1538V18.5641H11.4615V18.1538C11.4615 16.119 13.119 14.4615 15.1538 14.4615ZM34.8462 33.3333H15.1538C13.119 33.3333 11.4615 31.6759 11.4615 29.641V21.0256H38.5385V29.641C38.5385 31.6759 36.881 33.3333 34.8462 33.3333Z'
      fill='black'
    />
    <path
      d='M21.7179 28.4102H16.7949C16.122 28.4102 15.5641 28.9682 15.5641 29.641C15.5641 30.3138 16.122 30.8718 16.7949 30.8718H21.7179C22.3908 30.8718 22.9487 30.3138 22.9487 29.641C22.9487 28.9682 22.3908 28.4102 21.7179 28.4102Z'
      fill='black'
    />
  </svg>
)

export default Payment
